import { createPhoneOtpRecaptchaVerifier } from '@lotushealth/web_kit/auth';

import { auth } from '@/shared';

const recaptchaVerifier = createPhoneOtpRecaptchaVerifier({ auth });

export const getRecaptchaVerifier = recaptchaVerifier.getRecaptchaVerifier;
export const resetRecaptchaVerifier = recaptchaVerifier.resetRecaptchaVerifier;
